import { ApiError } from '../errors/api-error.js';
import { BaseApi } from './base.api.js';

export class WorkflowTaskApi extends BaseApi {
    constructor(client) {
        super(client, '/workflow-tasks');
    }

    async myInbox(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/my-inbox`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async decide(id, payload) {
        return this.client.post(`${this.basePath}/${id}/decision`, payload || {});
    }

    async submitFormFill(id, payload) {
        return this.client.post(`${this.basePath}/${id}/submit-form`, payload || {});
    }

    async forward(id, payload) {
        return this.client.post(`${this.basePath}/${id}/forward`, payload || {});
    }
}
